// CKagency : ajout en un clic des compléments proposés dans le tiroir panier.
// Le tiroir est re-rendu à chaque mise à jour, d'où l'écoute au niveau du document.
(function () {
  if (window.ckComplementReady) return;
  window.ckComplementReady = true;

  // Page /cart : la section est remontée sous la barre de livraison, en haut de la page.
  // On la place à côté de .js-contents-shipping (pas dedans) pour que le thème ne l'écrase pas.
  function placeCartSection() {
    const section = document.querySelector('[data-ck-section]');
    const target = document.getElementById('main-cart-shipping');
    if (section && target && !target.contains(section)) target.appendChild(section);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeCartSection);
  } else {
    placeCartSection();
  }

  // Page /cart : on re-rend la section du complément quand le panier change.
  document.addEventListener('cart:change', function () {
    const section = document.querySelector('[data-ck-section]');
    if (!section) return;
    fetch(`${window.location.pathname}?section_id=${section.dataset.ckSection}`)
      .then((r) => r.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ck-section]');
        if (fresh) section.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-ck-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    const cartDrawer = document.querySelector('cart-drawer');
    button.disabled = true;
    button.classList.add('is-loading');

    const body = {
      items: [{ id: Number(button.dataset.ckAdd), quantity: 1 }],
    };
    if (cartDrawer) {
      body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || response.message);

        if (cartDrawer) {
          cartDrawer.renderContents(response);
        } else {
          window.location = routes.cart_url;
          return;
        }

        // Pas de publish(cartUpdate) ici : le tiroir re-rendu l'écouterait et chargerait
        // le contenu de la page /cart à sa place.
        fetch(`${routes.cart_url}.js`)
          .then((r) => r.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: cart } }));
          })
          .catch(() => {});
      })
      .catch((error) => {
        console.error('ck-complement', error);
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  });
})();
